import { useFormik } from 'formik'
import React, { useEffect, useMemo } from 'react'
import { FieldsStack } from '../Common/Forms/FieldsStack'
import { use } from 'echarts'

const useNibbleForm = ({
  formScheme = [],
  model = null,
  defaultModelValues = {},
  validationScheme,
  onSubmit = (values) => {},
  Form = FieldsStack,
  debug = false,
}) => {
  
  const defaultValue = useMemo(() => {
    return formScheme.map(e => e.name).map(e => ({ [e]: null })).reduce((a, b) => ({ ...a, ...b }))
  }, [formScheme])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: ({ ...defaultValue, ...defaultModelValues, ...model }),
    validationSchema: validationScheme,
    onSubmit
  })

  // const [schema, setSchema] = useState(formScheme)
  const render = () => {
    return <Form itemsSchema={formScheme} validation={validation} debug={debug} />
  }

  return { validation, render }
}

export { useNibbleForm }
